(function() {

    var html = `
    <ul>
        <li class="hoverli">
            <a href="/epolls/latest_polls/">Polls</a>
            <ul class="hoverMenu">
                <li><a href="/epolls/latest_polls/">Latest Polls</a></li>
                <li><a href="/epolls/other/president-biden-job-approval-7320.html">Biden Job Approval</a></li>
                <li><a href="/epolls/other/direction_of_country-902.html">Direction of Country</a></li>
                <li><a href="/epolls/other/other/FavorabilityRatingsPoliticalLeaders.html">Political Leaders Favorability</a></li>
                <li><a href="/epolls/other/sotu/PresidentBidenApprovalIssues.html">Biden Approval on Issues</a></li>
                <li><a href="/epolls/latest_polls/2024/">Election 2024 Polls</a></li>
                <li><a href="/epolls/other/2024_generic_congressional_vote-7969.html">Generic Congressional Ballot</a></li>
                <li><a href="/epolls/latest_polls/state_of_the_union/">State of the Union Polls</a></li>
            </ul>
        </li>
        <li class="hoverli">
            <a href="/elections/2024/">Election 2024</a>
            <ul class="hoverMenu">
                <li><a class="static" href="/epolls/latest_polls/2024/">Latest 2024 Polls</a></li>
                <li><a class="static" href="/epolls/2024/president/us/2024_republican_presidential_nomination-7548.html">Republican Nomination</a></li>
                <li><a class="static" href="/epolls/2024/president/us/2024_democratic_presidential_nomination-7550.html">Democratic Nomination</a></li>
                <li><a class="static" href="/epolls/latest_polls/pres_general/">General Election Polls</a></li>
                <li><a class="static" href="/epolls/2024/president/us/general-election-trump-vs-biden-7383.html">Trump vs. Biden</a></li>
                <li><a class="static" href="/epolls/2024/president/us/general_election_desantis_vs_biden-7967.html">DeSantis vs. Biden</a></li>
                <li><a class="static" href="/epolls/other/2024_generic_congressional_vote-7969.html">Generic Ballot</a></li>
                <li><a class="static" href="/epolls/latest_polls/senate/">Senate Polls</a></li>
                <li><a class="static" href="/epolls/latest_polls/elections/">All Election Polls</a></li>
            </ul>
        </li>
        <li><a href="/video">Video</a></li>
        <li class="hoverli">
            <a href="javascript:void(0);">Writers</a>
            <ul class="hoverMenu masthead_staff_menu"></ul>
        </li>       
        <li><a href="/real_clear_opinion_research/index.html">Opinion Research</a></li>
        <li><a href="/daily_newsletters/">Newsletters</a></li>
        <li><a href="/podcasts/">Podcast</a></li>
        <li><a href="/realclearpublishing/">Publishing</a></li>
        <li><a href="/speakers.html">Speakers</a></li>
        <li style="background-color:#76767b"><a href="https://www.realclearmediafund.org">Donate</a></li>
    </ul>
    `;

    // Replace HTML content of all matching targets with above
    var containers = document.querySelectorAll('.masthead_nav_full');
    if(containers.length > 0) {
        for(var i = 0; i < containers.length; i++) {
            containers[i].innerHTML = html;
        }
    }

    //homepage navigation touch/click handlers
    var homeNavClick = function(e){

        var ele = $(e.target.parentNode);
        var menu = ele.find("ul");
        $( menu ).toggle();
    }

    //homepage navigation mouse event handlers
    var mainNavHover = function(){

        var over_submenu = false;

        $(".main-nav-bar .masthead_nav_full .hoverli").hover(
            function () {
                $(this).find('ul.hoverMenu').show();
            },
            function () {
                $(this).find('ul.hoverMenu').hide();
            }
        );
    }

    //homepage hover menu handlers
    //smart check for touch events to cover all devices without device/width checks
    $( ".main-nav-bar .masthead_nav_full ul li a" ).on({
        mouseenter: function(e) {
            mainNavHover(e);
        }, touchstart: function(e) {
            homeNavClick(e);
        }, touchmove: function(e) {
            homeNavClick(e);
        }
    });

})();